import { logError, ERROR_TYPE } from "../utils/newRelicLogger";
import criteoConfig from "../../common/CriteoAdvertsForRecs/config";
import getValueFromCookie from "../utils/getValueFromCookie";

const criteoSpotLightApi = async (criteoRequiredParams, isProd) => {
  const { id, price, isInStock } = criteoRequiredParams;
  const { currency, current, previous } = price;

  try {
    const { partnerId } = criteoConfig;
    const customerId = await window.asos.sdk.identity.customer.customerGuid();
    const retailerVisitorId = getValueFromCookie("featuresId");
    const countryCode = window.asos.webContext.getWebContext().browseCountry;

    if (!criteoConfig?.endPoints?.[countryCode]) return;

    const criteoPartnerId = isProd
      ? partnerId?.[countryCode]?.prod
      : partnerId?.[countryCode]?.testEnv;

    const params = new URLSearchParams({
      "criteo-partner-id": criteoPartnerId,
      "event-type": "viewItem",
      "page-id": "viewItemApiDesktop",
      "customer-id": customerId,
      ...(retailerVisitorId && {
        "retailer-visitor-id": retailerVisitorId,
      }),
      "parent-item": id,
      quantity: Number(isInStock),
      currency,
      nocall: "",
      "list-price": previous?.value ?? current?.value ?? 0,
      price: current?.value ?? 0,
      availability: Number(isInStock),
    });

    const response = await fetch(
      `${criteoConfig.endPoints[countryCode]}?${params}`,
    );

    if (!response.ok) {
      throw new Error("Failed to fetch Criteo spotlight data");
    }

    return await response.json();
  } catch (error) {
    logError(ERROR_TYPE.NonCriticalAppError, {
      message: error?.message ?? String(error),
      action: "CriteoSpotLightApi",
    });
    return;
  }
};

export default criteoSpotLightApi;
